export default {
  evaluation_list: {
    title: '委托评估公司一览',
    number_of_companies_answered: '已回答: {answered}/{total} 公司',
    number_of_companies_displayed: '显示 {total} 个中 {start}〜{end}  个',
    company_name: '公司名称',
    status: '状态',
    questionnaire: '调查表',
    plan: '计划',
    nothing: '没有符合的公司。',
  },
  evidence_options: {
    all_plan: '全部计划',
    plans_with_vouchers: '有凭证计划',
    no_voucher_plan: '无凭证计划',
  },
  table_headers: {
    company_name: '公司名称',
    status: '状态',
    esg_rating: 'ESG评级',
    esg_score: 'ESG得分',
    environment: '环境',
    social: '社会',
    governance: '管理',
    plan: '计划',
    questionnaire: '调查表',
    answer_date: '回答日期',
    answer_expires_date: '回答截止时间',
  },
  plan_list: {
    light: '轻型计划',
    starter: '启动计划',
    basic: '基本计划',
    standard: '标准计划',
    enterprize: '进取计划',
  },
}
